"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRefetchCounters = void 0;
const react_1 = require("react");
const use_refetch_queries_1 = require("./use-refetch-queries");
const context_1 = require("../../context");
const useRefetchCounters = () => {
    const { updateAggregationStatus } = (0, context_1.useProductTreeNodeReaggregationStatus)();
    const { refetchProductCounters } = (0, use_refetch_queries_1.useRefetchQueries)();
    const refetchCounters = (0, react_1.useCallback)((options) => {
        updateAggregationStatus(() => refetchProductCounters(options));
    }, [updateAggregationStatus, refetchProductCounters]);
    return {
        refetchCounters,
    };
};
exports.useRefetchCounters = useRefetchCounters;
